// extracted by mini-css-extract-plugin
export var chevron = "_w-d";
export var disabled = "_w-b";
export var error = "_w-c";
export var hideBorder = "_w-1";
export var icon = "_w-e";
export var input = "_w-0";
export var large = "_w-f";
export var open = "_w-9";
export var placeholder = "_w-a";
export var regular = "_w-5";
export var singleRowInput = "_w-2";
export var singleSelectInput = "_w-3 _w-0";
export var small = "_w-4";
export var spinnerContainer = "_w-i";
export var tag = "_w-7";
export var tagsContainer = "_w-8";
export var tagsInput = "_w-6 _w-0";
export var xSmall = "_w-g";
export var xxSmall = "_w-h";